import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const login = createAction(ACTION.LOGIN.REQUEST, (params) => params);
